import { formatDate } from '@angular/common';
import { AdminSuppliersList } from '../../../../../pages/admin-dashboard/admin-supplier/admin-supplier.model';
import { SupplierTableRow } from './supplier-table-component.model';

function toSupplierTableRow(
  supplier: AdminSuppliersList,
  index: number,
  isArabic: boolean,
  locale: string,
): SupplierTableRow {
  const date = supplier.createdOn ? formatDate(supplier.createdOn, 'mediumDate', locale) : '—';

  return {
    id: supplier.id,
    index,
    name: (isArabic ? supplier.titleAr : supplier.titleEn) || supplier.titleEn,
    dateCreated: date,
    activationStatus: supplier.isActive
      ? { titleEn: 'Active', titleAr: 'نشط' }
      : { titleEn: 'Inactive', titleAr: 'غير نشط' },
  };
}

export function toSupplierTableRows(
  suppliers: AdminSuppliersList[],
  isArabic: boolean,
  locale: string,
  firstIndex = 1,
): SupplierTableRow[] {
  return suppliers.map((c, i) => toSupplierTableRow(c, firstIndex + i, isArabic, locale));
}
